// Port of ContentErrorScreen() in android/.../ui/MainActivity.kt.
// Shown by an individual content tile (Image/Video/Iframe) when both the
// initial load AND the retry failed. The parent ContentDisplay still
// rotates past this tile via the safety advance.

export default function ContentErrorScreen() {
  return (
    <div className="absolute inset-0 bg-bg flex items-center justify-center">
      <div className="flex flex-col items-center gap-3 px-12 text-center max-w-md">
        <span className="text-white text-5xl font-black leading-none">:(</span>
        <h2 className="text-white text-[22px] font-semibold">Something is wrong</h2>
        <p className="text-muted text-sm leading-relaxed">
          This content could not be loaded.
          <br />Check the WeTook dashboard for details.
        </p>
      </div>
    </div>
  )
}
